module.exports = __webpack_public_path__ + "media/images/icon__sectionOpen-168ec7b0146ad003a9cf080ffe919fd7.png";